<template>
  <VView class="about" back-button-to="/menu" header="O Pufku">
    <VText>Pufek to urocze, magiczne i puchate stworzonko należące do gatunku Mopików. Zamieszkuje on krainę o nazwie Langoria.</VText>

    <VText><strong>Jak wyglądają Mopiki i czym się charakteryzują?</strong><br />
    Mopiki to magiczne istoty zrodzone z czystej magii!
    <br /><br />
    Te magiczne stworzonka nie posiadają rąk ani nóg, dlatego  do wszystkich czynności jakie wykonują używają telekinezy. Mogą poruszać przedmiotami na odległość nie przekraczającą 10 metrów oraz nie cięższymi niż dwukrotność swojej wagi (waga Pufka to ok. 30 kg). Oczywiście ta umiejętność może ulec zmianie, w zależności od doświadczenia danego Mopika 
    <br /><br />
    Mopiki nie latają, a jedynie lewitują maksymalnie do 1,5 metra nad ziemią i poruszają się z prędkością do 22 km/h. Niektóre, bardzo doświadczone Mopiki, osiągają prędkość nawet do 40km/h.
    <br /><br />
    Ich długość życia waha się od 215 do 280 lat – wpływ na żywotność Mopików ma ilość magii jaką w sobie rozwiną.
    </VText>
    
    <VText><strong>W jaki sposób Mopiki czerpią energię?</strong><br />
    Nasze stworzonka potrafią ją uzyskiwać z 3 źródeł:
    <br /><br />
    Główne i podstawowe źródło to jedzenie, które to po spożyciu błyskawicznie dematerializuje się, zamieniając w czystą energie potrzebną do życia i kreowania magii. 
    <br /><br />
    Kolejnym źródłem są magiczne kryształy - rzadkie twory magiczne posiadające dodatkowo właściwości teleportacyjne. 
    <br /><br />
    Ostatnim, najtrudniejszym sposobem uzyskania energii jest absorbcja któregoś z żywiołów. Niestety do tej formy czerpania mocy potrzebna jest doskonała znajomość magii  i jej perfekcyjne opanowanie. 
    </VText>

    <VText>Na początek to tyle informacji o naszym puchatym bohaterze.<br />Oglądajcie serial na YouTube aby dowiedzieć się więcej!</VText> 

    <VBlock max-width="500px">
      <transition name="bounceUp" appear>
        <VButton href="https://www.youtube.com/@PRZYGODY_PUFKA?sub_confirmation=1" target="_blank">Pufek na Youtube</VButton>
      </transition>
    </VBlock>
    
  </VView>
</template>

<script>
export default {
  name: 'about',
};
</script>

<style lang="scss" scoped>
.about {}
</style>
